import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../Context/authContext";

/**
 * AdminGuard
 * - Blocks non-admin users from accessing admin-only routes.
 * - Redirects unauthenticated users to /login.
 * - Redirects authenticated non-admin users to /unauthorized.
 */
const AdminGuard = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div className="w-full py-10 flex items-center justify-center text-slate-600">
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (user?.role !== "admin") {
    return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default AdminGuard;

